const outputs = {
  zip: '94102',
};

export default outputs;
